import type { KeyValuePair } from './normalizeSectionInputs';

/**
 * Collect KeyValuePair[] from a container using `data-id` for inputs, textarea, and select.
 * - Checkbox/Radio: serialize checked state as 'true'/'false'
 * - Other inputs/textarea/select: serialize string value (empty string if undefined)
 */
export function collectPairsFromContainer(container: Element | null): KeyValuePair[] {
  if (!container) return [];
  const pairs: KeyValuePair[] = [];
  container.querySelectorAll('input, textarea, select').forEach((el) => {
    const dataId = (el as HTMLElement).getAttribute('data-id');
    if (!dataId) return;

    if (el instanceof HTMLInputElement) {
      if (el.type === 'checkbox') {
        pairs.push({ key: dataId, value: el.checked ? 'true' : 'false' });
      } else if (el.type === 'radio') {
        pairs.push({ key: dataId, value: el.checked ? 'true' : 'false' });
      } else if (el.type !== 'file') {
        pairs.push({ key: dataId, value: el.value ?? '' });
      }
      // skip file inputs
    } else if (el instanceof HTMLTextAreaElement) {
      pairs.push({ key: dataId, value: el.value ?? '' });
    } else if (el instanceof HTMLSelectElement) {
      pairs.push({ key: dataId, value: el.value ?? '' });
    }
  });
  return pairs;
}
